import "./PaginationFooter.scss";

export default {
  name: "PaginationFooter",
  props: {
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 25
    },
    totalItems: {
      type: Number,
      default: 0
    },
    itemsPerPageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mobile() {
      return Boolean(
        this.$vuetify &&
          this.$vuetify.breakpoint &&
          this.$vuetify.breakpoint.mobile
      );
    },
    formattedItemsPerPageOptions() {
      return this.itemsPerPageOptions.map(option => ({
        text: String(option),
        value: option
      }));
    },
    totalPages() {
      if (this.currentItemsPerPage === -1) return 1;
      const pageCount = Math.ceil(this.totalItems / this.currentItemsPerPage);
      return Math.max(pageCount, 1);
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit("update:page", Number(value));
      }
    },
    currentItemsPerPage: {
      get() {
        return this.itemsPerPage;
      },
      set(value) {
        this.$emit("update:items-per-page", Number(value));
      }
    },
    itemCountStart() {
      if (!this.totalItems) return 0;
      if (this.currentItemsPerPage === -1) return 1;
      return (this.currentPage - 1) * this.currentItemsPerPage + 1;
    },
    itemCountEnd() {
      if (this.currentItemsPerPage === -1) return this.totalItems;
      return Math.min(
        this.currentPage * this.currentItemsPerPage,
        this.totalItems
      );
    },
    rangeLabel() {
      return `${this.itemCountStart} - ${this.itemCountEnd} von ${this.totalItems}`;
    },
    paginationButtons() {
      return this.createPaginationButtons(this.currentPage, this.totalPages);
    }
  },
  methods: {
    goToPage(targetPage) {
      if (this.disabled) return;
      if (!Number.isFinite(targetPage)) return;
      if (
        targetPage < 1 ||
        targetPage > this.totalPages ||
        targetPage === this.currentPage
      ) {
        return;
      }
      this.currentPage = targetPage;
    },
    previousPage() {
      if (this.disabled) return;
      if (this.currentPage <= 1) return;
      this.currentPage -= 1;
    },
    nextPage() {
      if (this.disabled) return;
      if (this.currentPage >= this.totalPages) return;
      this.currentPage += 1;
    },
    createPaginationButtons(page, maxPage) {
      if (maxPage <= 7) {
        return Array.from({ length: maxPage }, (_, idx) => idx + 1);
      }

      if (page < 3) {
        return [1, 2, 3, "ellipsis-right", maxPage];
      }

      if (page > maxPage - 2) {
        return [1, "ellipsis-left", maxPage - 2, maxPage - 1, maxPage];
      }

      if (page === 3) {
        return [1, page - 1, page, page + 1, "ellipsis-right", maxPage];
      }

      if (page === maxPage - 2) {
        return [1, "ellipsis-left", page - 1, page, page + 1, maxPage];
      }

      return [
        1,
        "ellipsis-left",
        page - 1,
        page,
        page + 1,
        "ellipsis-right",
        maxPage
      ];
    }
  }
};
